import React from "react";

// The casual, friendly "brain": one glance tells you how the island feels
// right now, and the three forces (Traffic, Weather, News) that decide it.
const stateFor = (score) => (score >= 70 ? "stable" : score >= 45 ? "elevated" : "critical");
const accentFor = (score) => (score >= 70 ? "#37d39a" : score >= 45 ? "#ffce4d" : "#ff6b5e");
const LABELS = { stable: "GOOD", elevated: "TENSE", critical: "STRAINED" };

const arrow = (e) => (e === "positive" ? "fa-arrow-trend-up" : e === "negative" ? "fa-arrow-trend-down" : "fa-minus");

const IslandPulse = ({ mood, prediction }) => {
  if (!mood) return null;
  const score = Math.max(0, Math.min(mood.mood_score ?? 0, 100));
  const st = stateFor(score);
  const accent = accentFor(score);
  const deg = Math.round((score / 100) * 360);
  const summary = mood.summary || (mood.now && mood.now[0]) || "Reading the island…";
  const pillars = mood.pillars || [];
  const pred = prediction || {};
  const md = pred.mood || {};
  const predIcon = md.direction === "up" ? "fa-arrow-trend-up" : md.direction === "down" ? "fa-arrow-trend-down" : "fa-arrow-right-long";

  return (
    <div className={`panel entrance resilience-brain rb-${st} island-pulse`} data-testid="island-pulse-panel" style={{ ["--rb-accent"]: accent }}>
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic rb-ic"><i className="fa-solid fa-hand-holding-heart" /></div>
          Island Pulse
        </div>
        <span className="rb-live"><span className="live-dot" /> live · what&apos;s happening in Barbados</span>
      </div>

      <div className="pulse-top">
        <div className="rb-ring-wrap" data-testid="pulse-dial">
          <div className="rb-ring" style={{ background: `conic-gradient(${accent} ${deg}deg, rgba(255,255,255,0.08) ${deg}deg)` }}>
            <div className="rb-ring-in"><b data-testid="pulse-score">{score}</b><span>/100</span></div>
          </div>
          <div className={`badge rb-badge rb-${st}`} data-testid="pulse-mood-badge" style={{ color: accent }}>
            {(mood.mood_text || LABELS[st]).toUpperCase()}
          </div>
          <div className="rb-ring-lab">Island Mood</div>
        </div>

        <div className="pulse-main">
          <div className="pulse-summary" data-testid="pulse-summary">{summary}</div>
          {md.text && (
            <div className={`pulse-forecast pf-${md.direction || "flat"}`} data-testid="pulse-forecast">
              <span className="pf-tag"><i className={`fa-solid ${predIcon}`} /> Next hour</span>
              <span className="pf-text">{md.text}</span>
              {typeof md.score === "number" && <span className="pf-score">→ {md.score}</span>}
            </div>
          )}
          <div className="pulse-pillars" data-testid="pulse-pillars">
            {pillars.map((p) => (
              <div key={p.key} className={`pulse-pillar pp-${p.effect}`} data-testid={`pulse-pillar-${p.key}`}>
                <div className="pp-top">
                  <span className="pp-ic"><i className={`fa-solid ${p.icon}`} /></span>
                  <span className="pp-name">{p.label}</span>
                  <span className={`pp-arrow ${p.effect}`}><i className={`fa-solid ${arrow(p.effect)}`} /></span>
                </div>
                <div className="pp-value">{p.value}</div>
                <div className="pp-note">{p.note}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IslandPulse;
